import {mergeProperties} from "../components/Utility";
import moment from "moment-timezone";

const timezone = 'Asia/Kolkata';
export const getFormData = (data) => {
    const initialData = {
        transactionType: '',
        amount: '',
        type: 'Is Fixed',
        transactionDate: '',
        schedules: {
            frequency: 'Monthly',
            dayOfMonth: ''
        },
        endDate: '',
        description: ''
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getTableColumns = ({ActionDropdown, deleteHandler}) => {
    let tableColumns = [
        {header: "Transaction Type", field: "transactionType"},
        {header: "Amount", field: "amount"},
        {header: "Type", field: "type"},
        {header: "Frequency", field: "frequency"},
        {header: "Transaction Date", field: "transactionDate"},
        {header: "End Date", field: "endDate"},
    ];

    tableColumns.push({
        header: "Action",
        disableSorting: true,
        field: "action",
        align: "right",
        render: (row) => <ActionDropdown row={row} edit={true} view={true} onDelete={deleteHandler}/>,
    });

    return tableColumns;
};

export const getTableData = ({items = [], list}) => {
    const {
        items: notApplicableList,
        status: notApplicableListStatus,
    } = list.notApplicable;

    if (!Array.isArray(items)) return [];
    return items.map((item) => ({
        id: item.id,
        transactionType: notApplicableListStatus === "success" ? notApplicableList[item.transactionType] : "-",
        amount: item.amount,
        type: item.type,
        frequency: item?.schedules?.frequency,
        dayOfMonth: item?.schedules?.dayOfMonth,
        transactionDate: moment(item.transactionDate).tz(timezone).format('MMM DD, YYYY, hh:mm A'),
        endDate: item.endDate ? moment(item.endDate).tz(timezone).format('MMM DD, YYYY, hh:mm A') : "-",
    }));
};

export const getDetailData = ({item, list}) => {
    if (!item) return {details: {}};
    const {
        items: notApplicableList,
        status: notApplicableListStatus,
    } = list.notApplicable;

    return {
        details: {
            id: item.id,
            transactionType: notApplicableListStatus === "success" ? notApplicableList[item.transactionType] : "-",
            amount: item.amount,
            type: item.type,
            frequency: item?.schedules?.frequency,
            dayOfMonth: item?.schedules?.dayOfMonth,
            transactionDate: item.transactionDate ? moment(item.transactionDate).tz(timezone).format('MMM DD, YYYY, hh:mm A') : "-",
            endDate: item.endDate ? moment(item.endDate).tz(timezone).format('MMM DD, YYYY, hh:mm A') : "-",
            lastProcessed: item.lastProcessed ? moment(item.lastProcessed).tz(timezone).format('MMM DD, YYYY, hh:mm A') : "-",
            description: item.description
        },
    };
};
